var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.Error
    ? _c(
        "section",
        [
          _c(
            "v-dialog",
            {
              attrs: { width: "500", persistent: "" },
              model: {
                value: _vm.Error,
                callback: function ($$v) {
                  _vm.Error = $$v
                },
                expression: "Error",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", {
                    staticClass: "error-title",
                    domProps: { innerHTML: _vm._s(_vm.Error.title) },
                  }),
                  _c(
                    "v-card-text",
                    [
                      _c("v-icon", [_vm._v("mdi-accept")]),
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.Error.msg) },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c("Button", { attrs: { click: () => _vm.Close() } }, [
                        _vm._v("Cerrar"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }